/**
 * React component for rendering Velt comment elements in Slate editor.
 * This component renders the <velt-comment-text> custom element.
 *
 * Note: velt-comment-text is an inline element, so it should only contain text nodes
 * or other inline elements, never block elements like <p>.
 */
import React from 'react';
import { Constants } from '@/constants/common';
export const SlateVeltComment = (props) => {
    const { attributes, children, element } = props;
    const annotationId = element === null || element === void 0 ? void 0 : element.annotationId;
    // Use React.createElement to avoid TypeScript JSX type checking for custom web component
    // velt-comment-text is an inline element, so children should be inline content only
    return React.createElement('velt-comment-text', Object.assign({ [Constants.ATTRIBUTES.ANNOTATION_ID]: annotationId }, attributes), children);
};
